import React from "react";
import { Paper } from "@mui/material";

const SectionCard = React.forwardRef(function SectionCard(
  { children, className = "", sx, ...props },
  ref
) {
  return (
    <Paper ref={ref} className={className} sx={sx} {...props}>
      {children}
    </Paper>
  );
});

export default SectionCard;